import Highcharts, { SeriesLineOptions } from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import Typography from "@portal/components/atoms/v2/typography";
import { GetLineSeries, RiskData } from "../../../components/highcharts/riskData/RiskData";
import useFundPriceHistory from "@portal/hooks/useFundPriceHistory/[isin]";
import { useMemo } from "react";
import PageSpinner from "@portal/components/molecules/v2/pageSpinner";

interface Props {
  texts: string[];
}

export const RiskInfo = ({ texts }: Props) => {
  const { fundPriceHistoryList: norneAksje, isLoading: norneAksjeIsLoading } = useFundPriceHistory({
    isin: "NO0010867682",
    fromDate: "2020-12-09",
  });
  const { fundPriceHistoryList: norne50, isLoading: norne50IsLoading } = useFundPriceHistory({
    isin: "SE0015194634",
    fromDate: "2020-12-09",
  });
  const { fundPriceHistoryList: norneRenter, isLoading: norneRenteIsLoading } = useFundPriceHistory({
    isin: "SE0013914645",
    fromDate: "2020-12-09",
  });

  const sortedNorneAksjeData = useMemo(() => {
    norneAksje?.sort((a, b) => {
      return Date.parse(a.navDate) - Date.parse(b.navDate);
    });
    return norneAksje;
  }, [norneAksje]);

  const sortedNorne50Data = useMemo(() => {
    norne50?.sort((a, b) => {
      return Date.parse(a.navDate) - Date.parse(b.navDate);
    });
    return norne50;
  }, [norne50]);

  const sortedNorneRenterData = useMemo(() => {
    norneRenter?.sort((a, b) => {
      return Date.parse(a.navDate) - Date.parse(b.navDate);
    });
    return norneRenter;
  }, [norneRenter]);

  const options = useMemo(() => {
    const ds = [] as SeriesLineOptions[];
    ds.push(GetLineSeries("NO0010867682", "Norne Aksje", "#02304b", sortedNorneAksjeData ?? []));
    ds.push(GetLineSeries("NO0010867682", "Norne Kombi 50", "#ffbd01", sortedNorne50Data ?? []));
    ds.push(GetLineSeries("NO0010867682", "Norne Rente", "#50c878", sortedNorneRenterData ?? []));

    return RiskData(ds);
  }, [sortedNorneAksjeData, sortedNorne50Data, sortedNorneRenterData]);

  return (
    <div className="flex flex-col my-3 px-1">
      <Typography variant="Body">{texts[0]}</Typography>
      {norneAksjeIsLoading || norne50IsLoading || norneRenteIsLoading ? (
        <PageSpinner />
      ) : (
        <div className="flex flex-col my-3 border rounded-md w-full p-1 bg-white">
          <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
      )}
      <Typography variant="Body">{texts[1]}</Typography>
      <Typography variant="Body">{texts[2]}</Typography>
    </div>
  );
};
